import axios from "axios";
import Cookies from "js-cookie";

export const apiInstanceWithAccessToken = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASEURL}/api/v1`,
});
// Add a request interceptor to attach the access token to outgoing requests
apiInstanceWithAccessToken.interceptors.request.use(
  async (config) => {
    const consumerAccessToken = Cookies.get("consumerAccessToken");
    if (consumerAccessToken) {
      // Attach the access token to the Authorization header
      config.headers["Authorization"] = `Bearer ${consumerAccessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token expiration and refresh
apiInstanceWithAccessToken.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // const navigate = useNavigate();
    // Handle token expiration and refresh
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      try {
        originalRequest._retry = true;
        // Attempt to refresh access token
        const staticAccessToken = process.env.REACT_APP_STATICACCESSTOKEN;
        const refreshToken = Cookies.get("consumerRefreshToken");
        if (refreshToken) {
          const response = await axios.post(
            `${process.env.REACT_APP_API_BASEURL}/api/v1/oauth/refresh/token`,
            {
              refresh_token: refreshToken,
            },
            {
              headers: {
                Authorization: `Bearer ${staticAccessToken}`,
                "Content-Type": "application/json",
              },
            }
          );
          const token_v1 = response?.data?.data?.token_v1;
          console.log(token_v1, "response", response);
          // Update access token in cookies
          if (token_v1) {
            Cookies.set("consumerRefreshToken", token_v1?.refresh_token);
            Cookies.set("consumerAccessToken", token_v1?.access_token, {
              expires: token_v1?.access_token_expire,
            });
            // Retry the original request
            error.config.headers[
              "Authorization"
            ] = `Bearer ${token_v1?.access_token}`;
            return apiInstanceWithAccessToken.request(originalRequest);
          }
        } else {
          // No refresh token available, redirect to login page or handle logout
          // navigate("/login");
          console.error("Token refresh failed:");

          Cookies.removeItem("consumerAccessToken");
          Cookies.removeItem("consumerRefreshToken");
          window.location.href = "/";
        }
      } catch (refreshError) {
        // Refresh token failed, redirect to login page or handle logout
        // navigate("/login");
        console.log(refreshError, "refreshError");
        console.error("Token refresh failed:");
        Cookies.removeItem("consumerAccessToken");
        Cookies.removeItem("consumerRefreshToken");
        window.location.href = "/";
        return false;
      }
    }
    return Promise.reject(error);
  }
);

export const apiInstanceWithStaticToken = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASEURL}/api/v1`,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_STATICACCESSTOKEN}`,
  },
});
